import { Component, OnInit, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { PqrsFacultadesService } from 'src/app/servicios/pqrs-facultades.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Loading } from 'src/app/Class/Loading';
declare var $: any;

@Component({
  selector: 'app-pqrs-facultades',
  templateUrl: './pqrs-facultades.component.html',
  styleUrls: ['./pqrs-facultades.component.css']
})
export class PqrsFacultadesComponent implements OnInit, OnDestroy {

  public dtOptions: DataTables.Settings[] = [ DTConfig.dtConf, DTConfig.dtConf, DTConfig.dtConf ];
  public dtTrigger: Subject<any> = new Subject();
  Toast = Swal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 3000 });
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;

  public idFacultad: any;
  public facultad: any = {};
  public formAsignacion: FormGroup;
  public formDevolucion: FormGroup;
  // public formRechazar: FormGroup;
  public formRespuesta: FormGroup;
  public listadoNuevas: any = [];
  public listadoAsignadas: any = [];
  public listadoDevueltas: any = []; 
  public integrantes: any = [];
  public detalles: any = { documentos:[], documentosRespuesta: [] };
  public errores = [];
  public server = '';
  public file: any;
  index: number;

  constructor( private service: PqrsFacultadesService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               public loading: Loading ) {
              
                this.server = service.getServe();

                this.getListado(false);

                this.formAsignacion = this.fb.group({
                      id_solicitud: ['', Validators.required],
                      id_facultad: [ ],
                      id_integrante: ['', Validators.required],
                      observaciones: ['']
                 });

                this.formDevolucion = this.fb.group({
                  id_solicitud: ['', Validators.required],
                  observaciones: ['', Validators.required]
                 });
                // this.formRechazar = this.fb.group({
                //   id_solicitud: ['', Validators.required],
                //   observaciones: ['', Validators.required]
                //  });
                this.formRespuesta = this.fb.group({
                  id_solicitud: ['', Validators.required],
                  id_facultad: [ , Validators.required],
                  observaciones: ['', Validators.required],
                  archivo: []
                 });

                 
    }

  public getListado(render) {
    this.loading.estado = true;

    this.route.params
    .subscribe( (parametros:any) => {
      this.idFacultad = parametros.id;

      this.service.getPQRS(this.idFacultad)
      .subscribe((data:any) => {
        this.facultad = data.facultad ? data.facultad : {};

        this.listadoNuevas =  data.solicitudesNuevas ? data.solicitudesNuevas.pqrs : [];
        this.listadoAsignadas = data.solicitudesAsiganadas ? data.solicitudesAsiganadas.pqrs : [];
        this.listadoDevueltas = data.solicitudesDevueltas ? data.solicitudesDevueltas.pqrs : [];
        this.integrantes = this.facultad.integrantes ? this.facultad.integrantes : [];
        
        this.loading.estado = false;
        if (render) {
          this.Toast.fire({ type: 'success', title: 'Listados actualizados exitosamente' });
          this.rerender();
        }
        this.dtTrigger.next();
      }, err => { this.loading.estado = false; });
    });

  }

  ngOnInit() {}

  ngOnDestroy(): void { this.dtTrigger.unsubscribe(); }

  rerender(): void {
    this.dtElements.forEach((dtElement: DataTableDirective) => {
      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    });
  }

  openModalDetalles(item, index) {
    this.index = index;
    this.detalles = item;
    $('#ModaldetalleSolicitud').modal('show');
  }

  openModalAsinar(item, index) {
    this.index = index;
    $('.modal').modal('hide');
    this.formAsignacion.reset({ id_solicitud: item.id, id_facultad: this.facultad.id });
    this.detalles = item;
    $('#ModalAsignarSolicitud').modal('show');
  }


  openModalDevolver(item, index) {
    this.index = index;
    $('.modal').modal('hide');
    this.formDevolucion.reset({ id_solicitud: item.id });
    this.detalles = item;
    $('#ModalDevolverSolicitud').modal('show');
  }

  openModalResponder(item, index) {
    this.index = index;
    $('.modal').modal('hide');
    this.formRespuesta.reset({ id_solicitud: item.id, id_facultad: this.facultad.id, observaciones: '' });
    this.detalles = item;
    $('#ModalResponderSolicitud').modal('show');
  }

  guardarAsignacion() 
  {
    this.loading.estado = true;

    this.service.AsignarPQRS(this.formAsignacion.value)
    .subscribe( (data:any)  => {
      if ( data['success']) {
        
        this.listadoNuevas =  data.solicitudesNuevas ? data.solicitudesNuevas.pqrs : [];
        this.listadoAsignadas = data.solicitudesAsiganadas ? data.solicitudesAsiganadas.pqrs : [];
        this.listadoDevueltas = data.solicitudesDevueltas ? data.solicitudesDevueltas.pqrs : [];

        $('.modal').modal('hide');
        this.Toast.fire({ type: 'success', title: 'Solicitud asignada exitosamente' });
        this.rerender();

      } else {
        this.errores = data['errores'];
      }
      this.loading.estado = false;
    });
  }


  guardarDevolucion() 
  {
    this.loading.estado = true;

    this.service.devolverSolicitud(this.formDevolucion.value)
    .subscribe( (data:any)  => {
      if (data ['success']) {
        
        this.listadoNuevas =  data.solicitudesNuevas ? data.solicitudesNuevas.pqrs : [];
        this.listadoAsignadas = data.solicitudesAsiganadas ? data.solicitudesAsiganadas.pqrs : [];
        this.listadoDevueltas = data.solicitudesDevueltas ? data.solicitudesDevueltas.pqrs : [];
        
        $('.modal').modal('hide');
        this.Toast.fire({ type: 'success', title: 'Solicitud devuelta exitosamente' });
        this.rerender();

      } else {
        this.errores = data['errores'];
      }

      this.loading.estado = false;
    });
  }

  

  guardarRespuesta() 
  {
    this.loading.estado = true;

    this.service.responderSolicitud(this.formRespuesta.value)
    .subscribe( (data:any)  => {
      if (data ['success']) {
        
        this.listadoNuevas =  data.solicitudesNuevas ? data.solicitudesNuevas.pqrs : [];
        this.listadoAsignadas = data.solicitudesAsiganadas ? data.solicitudesAsiganadas.pqrs : [];
        this.listadoDevueltas = data.solicitudesDevueltas ? data.solicitudesDevueltas.pqrs : [];

        $('.modal').modal('hide');
        this.Toast.fire({ type: 'success', title: 'Respuesta enviada exitosamente' });
        this.rerender();

      } else {
        this.errores = data['errores'];
      }
      
      this.loading.estado = false;
    });
  }

  onFileSelect(event) 
  {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.formRespuesta.get('archivo').setValue(file);
    }
  }
  validarExtension (event) {
    var archivoInput = document.getElementById('fileUpload');
    var archivoRuta = (<HTMLInputElement>archivoInput).value;
    var extPermitidas = /(.pdf)$/i; 
 
     if(!extPermitidas.exec(archivoRuta)){
       $('#Modalerrores').modal({ backdrop: 'static', keyboard: true, show: true });
       (<HTMLInputElement>archivoInput).value = '';
       return this.errores = ["Solo se aceptan archivos con extensión PDF"];
     
 }else{
       this.onFileSelect(event);
     }
   }

}
